var classes = {"tooltip":"MX352","tooltipOpened":"OFydy"};

export { classes as default };
